import { Component } from '@angular/core';

import { injectTranslate, TranslatePipe } from '@core/i18n-legacy';
import { AddMemberAction, AddMemberFlowChoiceCardI } from '@core/tellent-types';
import {
  DialogBodyComponent,
  DialogComponent,
  DialogHeaderComponent,
} from '@core/user-interface-legacy';

import { AddMemberFlowChoiceCardComponent } from './add-member-flow-choice-card/add-member-flow-choice-card.component';

type AddMemberFlowChoiceDialogData = {};

type AddMemberFlowChoiceDialogResult = { action: AddMemberAction };

@Component({
  selector: 'tla-add-member-flow-choice-dialog',
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    AddMemberFlowChoiceCardComponent,
    TranslatePipe,
  ],
  templateUrl: './add-member-flow-choice-dialog.component.html',
  styleUrl: './add-member-flow-choice-dialog.component.less',
  providers: [],
})
export class AddMemberFlowChoiceDialogComponent extends DialogComponent<
  AddMemberFlowChoiceDialogData,
  AddMemberFlowChoiceDialogResult
> {
  private readonly t = injectTranslate();

  public cardOptions: AddMemberFlowChoiceCardI[] = [
    {
      heading: this.t('tlc.members.add_member_flow_choice_dialog.options.invite_member.heading'),
      subheading: this.t(
        'tlc.members.add_member_flow_choice_dialog.options.invite_member.subheading',
      ),
      icon: 'person-add',
      action: AddMemberAction.InviteMember,
    },
    {
      heading: this.t(
        'tlc.members.add_member_flow_choice_dialog.options.add_employee_for_preonboarding.heading',
      ),
      subheading: this.t(
        'tlc.members.add_member_flow_choice_dialog.options.add_employee_for_preonboarding.subheading',
      ),
      icon: 'timer-sand',
      action: AddMemberAction.AddEmployeeForPreonboarding,
    },
    {
      heading: this.t(
        'tlc.members.add_member_flow_choice_dialog.options.add_employee_without_access.heading',
      ),
      subheading: this.t(
        'tlc.members.add_member_flow_choice_dialog.options.add_employee_without_access.subheading',
      ),
      icon: 'playlist-add',
      action: AddMemberAction.AddEmployeeWithoutAccess,
    },
  ];

  public proceed(action: AddMemberAction): void {
    this.dialogRef.close({ action });
  }
}
